import { BackdropContext } from "context/BackdropProvider";
import { useContext } from "react";

export interface BackdropContextType {
  setBackdropEnable(state: boolean): void;
}

export const useBackdrop = (): BackdropContextType => useContext(BackdropContext);
